/******************************************************************
 * Archivo : client/src/components/Admin/reports/SurveyCSVExport/index.js
 * Proyecto: CB30
 * Módulo  : Reportes
 *
 * Propósito:
 * Permitir seleccionar una encuesta para exportar sus resultados
 * en formato CSV.
 *
 * Funcionalidad:
 * - Buscar encuestas por título.
 * - Filtrar dinámicamente la lista.
 * - Seleccionar una encuesta.
 * - Descargar el CSV de la encuesta seleccionada.
 *
 * Permiso:
 * REPORTES_ENCUESTAS_CSV_EXPORTAR
 ******************************************************************/

import React, { useState } from "react";
import { graphql } from "react-apollo";

// Query
import query from "../../../../queries/fetchAllSurveys";

// Componente existente de exportación
import ResultsToCSV from "../../surveys/Results/ResultsToCSV";

const SurveyCSVExport = props => {

  const [filtro, setFiltro] = useState("");
  const [encuestaSeleccionada, setEncuestaSeleccionada] =
    useState(null);

  if (props.data.loading) {
    return (
      <div className="container">
        <h2>Exportación CSV por encuesta</h2>
        <p>Cargando encuestas...</p>
      </div>
    );
  }

  if (props.data.error) {
    return (
      <div className="container">
        <h2>Exportación CSV por encuesta</h2>
        <p>{props.data.error.message}</p>
      </div>
    );
  }

  const surveys = props.data.surveys || [];

  const texto = filtro.toLowerCase();

  const encuestasFiltradas = surveys.filter(
    survey =>
      (survey.titulo || "")
        .toLowerCase()
        .includes(texto)
  );

  return (
    <div className="container">

      <h2>Exportación CSV por encuesta</h2>

      <p className="text-muted">
        Seleccione una encuesta para exportar sus resultados.
      </p>

      <hr />

      <div className="form-group">

        <label>
          <strong>Buscar encuesta</strong>
        </label>

        <input
          className="form-control"
          placeholder="Nombre de la encuesta..."
          value={filtro}
          onChange={e => {
            setFiltro(e.target.value);
            setEncuestaSeleccionada(null);
          }}
        />

      </div>

      {!encuestaSeleccionada && (

        <table className="table table-hover table-sm">

          <thead>
            <tr>
              <th>Encuesta</th>
            </tr>
          </thead>

          <tbody>

            {encuestasFiltradas.map(survey => (

              <tr
                key={survey.id}
                style={{ cursor: "pointer" }}
                onClick={() =>
                  setEncuestaSeleccionada(survey)
                }
              >

                <td>
                  {survey.titulo}
                </td>

              </tr>

            ))}

            {encuestasFiltradas.length === 0 && (

              <tr>
                <td className="text-muted">
                  No se encontraron encuestas.
                </td>
              </tr>

            )}

          </tbody>

        </table>

      )}

      {encuestaSeleccionada && (

        <div className="card">

          <div className="card-header">
            <strong>Encuesta seleccionada</strong>
          </div>

          <div className="card-body">

            <p>
              <strong>
                {encuestaSeleccionada.titulo}
              </strong>
            </p>

            <ResultsToCSV
              surveyId={encuestaSeleccionada.id}
            />

            <button
              type="button"
              className="btn btn-secondary ml-2"
              onClick={() =>
                setEncuestaSeleccionada(null)
              }
            >
              Volver a buscar
            </button>

          </div>

        </div>

      )}

    </div>
  );
};

export default graphql(query)(SurveyCSVExport);


// WEBPACK FOOTER //
// ./src/components/Admin/reports/SurveyCSVExport/index.js